module.exports = __webpack_public_path__ + "static/img/android-app-store-icon.38f4f00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/android-app-store-icon.png
// module id = Mf00
// module chunks = 1